import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import HeaderEN from "../../headerEN/headeren";
import FooterEN from "../../footerEN/footer";
import './policyrenewalalerts.scss';

const PolicyRenewalAlerts = () => {

  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
  
  },[])

  const [tabsList, setTabsList] = useState([{ text: "Travel Insurance", url: "travel-insurance" }, { text: "Life Insurance", url: "life-insurance" }])
  const [tab, setTab] = useState(0)

  return (
    <div class="main-fluid">
      <HeaderEN />
      {/* DESK TOP AND TABS SECTION STARTS HERE */}
      <div class="d-none d-md-block">
        <div class="polirenealt-tab-imagebannermain-en">
          <div class="polirenealt-banner-con-en">
            <div class="polirenealttab-banne-sec-en">
              <h1 class="polirenealt-banner-heading-en">Valued Services</h1>

              {/* TAB BUTTON SECTION STARTS HERE */}
              <div class="grpacc-covinsu-tab-btn-en">
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "risk-inspection-services"}>Risk Inspection Services</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "insurance-audits"}>Insurance Audits</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "valuation-services"}>Valuation services</div>
                <div class="grpacc-insu-tab-btn-item-active-en" onClick={() => window.location.href = "policy-renewalalerts"}>Policy Renewal Alerts</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "thermography-testing-insurance"}>Thermography Testing</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "employee-wellness-program"}>Employee Wellness Program</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}

              <div class="best-responsive-tab" id="myExampleBestResponsiveTab1" role="tablist" data-target-content="#myExampleTabsContent">
                {/* {
              tabsList && tabsList.length ? tabsList.map(( each, index ) => <div data-target-index={index} className={index == tab ? "active" : "def"} onClick={() => {
                setTab(index)
                window.location.href = "personalinsurance/" + each.url
              }}>{each.text}</div>) : null

            } */}
                {/* <div data-target-index="0">Travel Insurance</div>
            <div data-target-index="1" onClick={() => window.location.href = "personalinsurance/life-insurance"}>Life Insurance</div>
            <div data-target-index="2">Personal Accident Insurance</div>
            <div data-target-index="3">Relocation Insurance</div>
            <div data-target-index="4">Health Insurance</div>
            <div data-target-index="5">Art insurance</div>
            <div data-target-index="6">Golf Insurance</div>
            <div data-target-index="7">Motor Insurance</div>
            <div data-target-index="8">Housemaid Insurance</div>
            <div data-target-index="9">Home Insurance</div>
            <div data-target-index="10">Yacht Insurance</div> */}


              </div>
            </div>
          </div>
        </div>
        <div class="polirenealt-banner-con-en">
          <div class="polirenealt-bdy-en">
            <h2 class="pagetitle-en">PolicyRenewalAlerts</h2>
            <div class="polirenealt-dflex-en">
              {/* LEFT SIDE IMAGE SECTION STARTS HERE */}
              <div class="polirenealt-dlex-lft-en">
                {/* <h2 class="pagetitle-en">PolicyRenewalAlerts</h2> */}

                <p class="polirenealt-pg-txt-con">Content here</p>


                {/* <div class="polirenealt-keypoint-en">
              <div class="polirenealt-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
              <div class="polirenealt-keypoint-item-en"></div>

              <div class="polirenealt-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
              <div class="polirenealt-keypoint-item-en"></div>
            </div> */}

                {/* <h3 class="polirenealt-whykrinsu-title-en">Why KR Insurance Services ?</h3>
              <div class="clearfix"></div>

              <div class="polirenealt-pins-list-lftdksp-en">
                <div class="polirenealt-lt-one-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Competitive Terms</div>
                <div class="polirenealt-lt-two-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Prompt Claim Services</div>
                <div class="polirenealt-lt-one-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Wide Quote Comparisons</div>
                <div class="polirenealt-lt-two-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Best Insurance Industry Practices</div>
              </div> */}

              </div>
              {/* LEFT SIDE IMAGE SECTION ENDS HERE */}
              {/* RIGHT SIDE IMAGE SECTION STARTS HERE */}
              <div class="polirenealt-dlex-rgt-en">
                <img src={process.env.PUBLIC_URL + "/riskmanagementservices_images/tab_images/risk_management.png"} />
              </div>
              {/* RIGHT SIDE IMAGE SECTION ENDS HERE */}
            </div>



            {/* <p class="polirenealt-txt-con">We look forward to safeguard your risk through our Risk Inspection Services, Please contact us for further details or discussions on our offerings.</p> */}

            <h3 class="polirenealt-whykrinsu-title-en">Why KR Insurance Services ?</h3>
            <div class="clearfix"></div>

            <div class="polirenealt-pins-list-dksp-en">
              <div class="polirenealt-lt-one-dksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Competitive Terms</div>
              <div class="polirenealt-lt-two-dksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Prompt Claim Services</div>
              <div class="polirenealt-lt-one-dksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Wide Quote Comparisons</div>
              <div class="polirenealt-lt-two-dksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Best Insurance Industry Practices</div>
            </div>

            {/* <h3 class="polirenealt-page-sbu-title-en"></h3>

            <p class="polirenealt-txt-con"></p>
            
            <div class="polirenealt-kpnt-en">
              <div class="polirenealt-kpnt-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
              <div class="polirenealt-kpnt-item-en"></div>
              
              <div class="polirenealt-kpnt-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
              <div class="polirenealt-kpnt-item-en"></div>
            </div> */}

          </div>
        </div>
      </div>
      {/* DESK TOP AND TABS SECTION ENDS HERE */}

      {/* MOBILE PAGE STARTS HERE */}
      <div class="polirenealt-tab-imagebannermain-en hidden-desktop hidden-md-device hidden-lg">
        <div class="dropdown-sec">
          <select class="form-select" onChange={(e) => window.location.href = e.target.value}>
            <option value={"risk-inspection-services"}>Risk Inspection Services</option>
            <option value={"insurance-audits"}>Insurance Audits</option>
            <option value={"valuation-services"}>Valuation Services</option>
            <option value={"policy-renewalalerts"} selected class="active">Policy Renewal Alerts</option>
            <option value={"thermography-testing-insurance"}>Thermography Testing</option>
            <option value={"employee-wellness-program"}>Employee Wellness Program</option>
          </select>
        </div>
        <div class="polirenealt-mob-main-en">
          <h1 class="polirenealt-banner-heading-en">Policy Renewal Alerts</h1>
          <div class="polirenealt-mob-img-en">
            <img src={process.env.PUBLIC_URL + "/riskmanagementservices_images/tab_images/risk_management.png"} />
          </div>

          <p class="polirenealt-mob-txt-en">content here</p>

          {/* <div class="polirenealt-pins-list-mob-en">
        <div class="polirenealt-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
        <div class="polirenealt-pins-list-mob-item-en">To analyze risk prone areas and activities in your business operations.</div>
        <div class="polirenealt-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
        <div class="polirenealt-pins-list-mob-item-en">Inspection of electricity wirings, fire extinguishers, house-keeping, stacking etc.</div>
        <div class="polirenealt-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
        <div class="polirenealt-pins-list-mob-item-en">Inspection of ground levels, soil conditions, structure strengths.</div>
        <div class="polirenealt-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
        <div class="polirenealt-pins-list-mob-item-en">Route survey inspections for over dimensional consignments.</div>
        <div class="polirenealt-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
        <div class="polirenealt-pins-list-mob-item-en">Suggest risk improvement / loss mitigation measures.</div>
        <div class="polirenealt-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
        <div class="polirenealt-pins-list-mob-item-en">Collection of information related to previous major losses.</div>
        <div class="polirenealt-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
        <div class="polirenealt-pins-list-mob-item-en">Inspection carried out by experienced engineers.</div>
      </div> */}

          {/* <p class="polirenealt-mob-txt-en">We look forward to safeguard your risk through our Risk Inspection Services, Please contact us for further details or discussions on our offerings.</p> */}

          <h3 class="polirenealt-whykrinsu-mob-title-en">Why KR Insurance Services ?</h3>

          <div class="polirenealt-mob-whykrlist-en">
            <div class="polirenealt-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Competitive Terms</div>
            <div class="polirenealt-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Prompt Claim Services</div>
            <div class="polirenealt-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Wide Quote Comparisons</div>
            <div class="polirenealt-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /> Best Insurance Industry Practices</div>
          </div>

          {/* <h3 class="polirenealt-subtitle-en"></h3>

      <p class="polirenealt-mob-txt-en"></p>


      <div class="polirenealt-pins-list-mob-en">
        <div class="polirenealt-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
        <div class="polirenealt-pins-list-mob-item-en"></div>

        <div class="polirenealt-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} /></div>
        <div class="polirenealt-pins-list-mob-item-en"></div>
      </div> */}

        </div>
      </div>
      {/* MOBILE PAGE ENDS HERE */}

      {/* FOOTER SECTION STARTS HERE */}
      <FooterEN />
      {/* FOOTER SECTION ENDS HERE */}
    </div>
  );
}

export default PolicyRenewalAlerts;
